var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ClassifierTree/dynamicGroupMode.ts";
import { createEvent, restore } from 'effector';
export var setDynamicGroupMode = createEvent({
  name: "setDynamicGroupMode",
  sid: "-8a16ki"
});
export var dynamicGroupMode$ = restore(setDynamicGroupMode, false, {
  name: "dynamicGroupMode$",
  sid: "jyh5ve"
});